import styled from 'styled-components'

export const AgendaYoutubeCard = styled.div<{ $isOpen: boolean }>`
  font-family: 'Euclid Circular A', sans-serif;
  width: 512px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* gap: 3rem; */

  .agenda-youtube {
    &-video {
      &-desc {
        ${(props) => (props.$isOpen ? 'height: auto;' : 'height:  1.4rem;')}
        overflow: ${(props) => (props.$isOpen ? 'visible' : 'hidden')};
        transition: all, 0.4s cubic-bezier(1, 0, 1, 0);
      }
      &-button {
        background-color: transparent;
        border: none;
        padding: 0.2rem 0 0 0;
        text-align: left;
        cursor: pointer;
        color: #111;
        font: normal normal bold 16px Euclid Circular A;
        letter-spacing: 0px;
      }
      &-date {
        margin-top: 2rem;
        display: block;

        font: normal normal normal 18px/23px Euclid Circular A;
        color: #707b93;
      }
    }
    &-header {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.5rem;
      &-profile-image {
        img {
          width: 62px;
          border-radius: 50%;
          object-fit: cover;
          object-position: center;
        }
      }
      &-profile-des {
        &-name {
          font: normal normal bold 20px/25px Euclid Circular A;
          color: #000000;
        }
        &-link {
          display: block;
          font: normal normal medium 18px/23px Euclid Circular A;
          color: #707b93;
        }
      }
    }

    &-body {
      margin-top: 4.55rem;
      &-post-image {
        width: 100%;
        overflow: hidden;
        border-radius: 10px;
        margin: 1rem 0;

        img {
          width: 100%;
          object-fit: cover;
          object-position: center;
        }
      }

      &-post-infos {
        &-item {
          display: inline-flex;
          flex-direction: row;
          align-items: center;
          gap: 6px;

          img {
            width: 24px;
          }

          &:not(:last-child) {
            margin-right: 1.8rem;
          }
        }
      }
    }
  }
`
